import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.875 8.25c0-1.23.656-2.379 1.75-3.008a3.48 3.48 0 0 1 3.5 0c1.066.63 1.75 1.778 1.75 3.008a3.54 3.54 0 0 1-1.75 3.035 3.48 3.48 0 0 1-3.5 0 3.48 3.48 0 0 1-1.75-3.035M3.25 17.957c0-2.707 2.16-4.895 4.867-4.895h2.488a4.89 4.89 0 0 1 4.895 4.895c0 .438-.383.793-.82.793H4.043a.794.794 0 0 1-.793-.793m16.652.793H16.13c.137-.246.246-.547.246-.875v-.219c0-1.64-.766-3.144-1.914-4.129.055 0 .11-.027.191-.027h1.668a4.446 4.446 0 0 1 4.43 4.43c0 .465-.383.82-.848.82m-4.84-7a3.15 3.15 0 0 1-2.187-.875c.547-.738.875-1.64.875-2.625 0-.71-.191-1.422-.52-2.023.52-.356 1.149-.602 1.832-.602 1.668 0 3.063 1.395 3.063 3.063a3.075 3.075 0 0 1-3.062 3.062"
    }, null, -1)
  ]))]))
}
export default { render: render }